<template>
  <div class="informationTemplate-tree-bd">
      <el-dialog v-drag-dialog
      :title="model.title"
      :visible.sync="visible"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="dialog-body">
        <!-- 用户信息 -->
        <el-form :model="form" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('crm_partner_administrators_dialog.yglymc')">
                <el-input v-model="form.oldadminName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('crm_partner_administrators_dialog.yglydlm')">
                <el-input v-model="form.oldAdminLoginName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
             <el-form-item :label="$t('crm_partner_administrators_dialog.xglymc')" prop="newAdminId" :rules="rules.newAdminId">
                <custom-select
                  v-model="form.newAdminId"
                  url="partnerOrganAdminList"
                  :params="{oldAdminId: form.oldAdminId,organId: form.organId}"
                  :props="{label: 'realName',value: 'userId'}"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                  @change="onNewLoginName"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
             <el-form-item :label="$t('crm_partner_administrators_dialog.xglydlm')" prop="newAdminLoginName" :rules="rules.newAdminLoginName">
                <el-input v-model="form.newAdminLoginName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
        <el-button type="primary" @click="saveAdmin">{{$t('Common.com_confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: ''
        };
      }
    }
  },
  data() {

    return {
      visible: false,
      form: {
        oldadminName: '',
        oldAdminLoginName: '',
        oldAdminId: '',
        organId: '',
        newAdminId: '',
        newAdminName: '',
        newAdminLoginName: ''
      },
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        newAdminId: [
          { required: true, message: this.$t('crm_partner_administrators_dialog.xglymcbx') }
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form = JSON.parse(this.resetForm);
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      if (this.model.type === 'edit') {
        this.form.oldAdminLoginName = this.data.adminLoginName;
        this.form.oldadminName = this.data.adminName;

        this.form.oldAdminId = this.data.adminId;
        this.form.organId = this.data.partnerOrgId;
      }
    },
    onNewLoginName(item) {
      this.form.newAdminLoginName = item.loginName;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveAdmin: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveEditAdmin();
      });
    },
    // 保存编辑分组
    saveEditAdmin: function () {
      this.$postJSON(apis.partnerOrganAdminUpdate, this.form).then((res) => {
        if (res) {
          this.$message({
            message: this.$t('Common.com_modify_success'),
            type: 'success'
          });
          this.closeDialog();
          this.$emit('success', this.form);
        }
      });
    }
  }
};
</script>

<style lang="scss">
</style>
